import { AppSettings } from '../app.settings';
import { CriticalScreenFiltersDataModel } from './critcal-screen-filters-data-model';

export class CriticalScreenFilterModel {
  screenCode: String = AppSettings.FILTER_SCREEN_CODE.VEHICLES_SCREEN;
  /** Filters are saved per user + screen + event; the backend rejects a save without it. */
  eventId?: String;
  filterData: CriticalScreenFiltersDataModel = new CriticalScreenFiltersDataModel();

  constructor(options?: {
    screenCode?: String,
    eventId?: String,
    filterData: CriticalScreenFiltersDataModel
  }) {
    if (options) {
      this.screenCode = options.screenCode;
      this.eventId = options.eventId;
      this.filterData = options.filterData;
    }
  }
};
